import React, { useState, useEffect, useLayoutEffect } from "react";
import axios from "axios";
import style from "../../css/dashboard/NotificationBar.module.css";
import { API_BASE_URL } from "../ApiConfig";
import { getSecureToken } from "../ApisService/apiService";

const NotificationBar = ({ isOpen, onClose }) => {
  const [notifications, setNotifications] = useState([]);

  useLayoutEffect(() => {
    if (isOpen) {
      fetchNotifications();
    }
  }, [isOpen]);

  const fetchNotifications = async () => {
                const { secrettoken, ts } = await getSecureToken();
    
    try {
      const response = await axios.get(`${API_BASE_URL}notification/featch_notification.php`,{
               headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    },
        withCredentials: true,
      })
      setNotifications(response.data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={style.offcanvas}>
      <div className={style.offcanvasHeader}>
        <h2>Notifications</h2>
        <button onClick={onClose} className={style.closeBtn}>&times;</button>
      </div>
      <div className={style.offcanvasBody}>
        {notifications.length === 0 ? (
          <p>No new notifications</p>
        ) : (
          notifications.map((notification) => (
            <div key={notification.id} className={style.notificationItem}>
             <p>  {notification.message}  </p>
              {notification.created_at}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationBar;
